// extracted by mini-css-extract-plugin
module.exports = {"related-stories-title":"styles-m__related-stories-title__AJOj8","related-stories":"styles-m__related-stories__2W36p"};